import { useCallback } from "react"; // 👈 FIX: Import useCallback
import { baseAxios } from "../apis";
import { useCsrfToken } from "./useCsrfToken";

// 👇 FIX: Correct the export and function definition
const useAuthedApi = () => {
  const { fetchCsrfToken } = useCsrfToken();

  const authedPost = useCallback(
    // 1. Accept an optional 'config' object as the third argument.
    async (url, payload = {}, config = {}) => {
      const token = await fetchCsrfToken();
      return baseAxios.post(url, payload, {
        // 2. Spread the incoming config to include things like 'params'.
        ...config,
        // 3. Merge headers to ensure the CSRF token is always included.
        headers: {
          ...config.headers,
          "X-CSRFToken": token,
        },
      });
    },
    [fetchCsrfToken]
  );
  const authedDelete = useCallback(
    // ✅ Now accepts a 'config' object
    async (url, config = {}) => {
      const token = await fetchCsrfToken();
      return baseAxios.delete(url, {
        ...config, // Spread the incoming config (which contains the params)
        headers: {
          ...config.headers,
          "X-CSRFToken": token,
        },
      });
    },
    [fetchCsrfToken]
  );

  const authedPatch = useCallback(
    async (url, payload, config = {}) => {
      const token = await fetchCsrfToken();
      return baseAxios.patch(url, payload, {
        ...config, // Pass along other config
        headers: {
          ...config.headers, // Preserve other headers if any
          "X-CSRFToken": token,
        },
      });
    },
    [fetchCsrfToken]
  );

  return { authedPost, authedDelete, authedPatch };
};

export default useAuthedApi;
